<template>
  <div class="content" ref="content">
    <div class="inner">
      <img class="item" :src="img.item1" alt="">
      <img class="item" :src="img.item2" alt="">
      <img class="item" :src="img.item5" alt="">
      <img class="item" :src="img.item3" alt="">
      <img class="item" :src="img.item4" alt="">
      <img class="btn" @click="totest" :src="img.btn" alt="">
    </div>
  </div>
</template>

<script>
  /* eslint-disable */
  import '@/assets/css/index.less'
  import {
    getPay
  } from '../assets/js/request'
  export default {
    name: 'Index',
    props: {
      msg: String
    },
    data() {
      return {
        img: {
          // bg:require('@/assets/img/bg.png'),
          item1: require('@/assets/img/item1.png'),
          item2: require('@/assets/img/item2.png'),
          item3: require('@/assets/img/item3.png'),
          item4: require('@/assets/img/item4.png'),
          item5: require('@/assets/img/item5.png'),
          btn: require("@/assets/img/btn.png"),
        },
        showbtn: false,
        payIndex: 0,
        code: '',
        showwrap: false,
        showpay: false,
        showwx: true,
        showzfb: true
      }
    },
    methods: {
      totest(){
        location.href = './test.html?asse_code=NEOFFIINT'
      },
    },
    mounted() {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>